import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createInterviews, getAInterview, resetState, updateAInterview } from "../features/interview/interviewSlicee";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";

let schema = yup.object().shape({
  title: yup.string().required("Title is Required"),
  videos: yup.string().required("Youtube Video Id is Required"),
  category: yup.string().required("Category is Required"),
});

const categories = ['news', 'interviews', 'destinations'];

const AddInterview = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.interview);
  const { isSuccess, isError, isLoading, createdInterview, interviewtitle, interviewVideos, interviewCategory, updatedInterview } = NewsState;

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getAInterview(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId, dispatch]);

  useEffect(() => {
    dispatch(resetState());
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess && createdInterview) {
      toast.success("Interview Added Successfully!");
    }
    if (isSuccess && updatedInterview) {
      toast.success("Interview Updated Successfully!");
      navigate("/admin/Interview-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading, createdInterview, updatedInterview, navigate]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: interviewtitle || "",
      videos: interviewVideos || "",
      category: interviewCategory || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: values };
        dispatch(updateAInterview(data));
        dispatch(resetState());
      } else {
        dispatch(createInterviews(values));
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Interview</h3>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Interview Title"
              name="title"
              onChng={formik.handleChange("title")}
              onBlr={formik.handleBlur("title")}
              val={formik.values.title}
            />
            <div className="error">{formik.touched.title && formik.errors.title}</div>
          </div>

          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter Youtube Video ID"
              name="videos"
              onChng={formik.handleChange("videos")}
              onBlr={formik.handleBlur("videos")}
              val={formik.values.videos}
            />
            <div className="error">{formik.touched.videos && formik.errors.videos}</div>
          </div>

          <div className="mt-4">
            <label className="form-label">Select Category</label>
            <select
              className="form-control"
              name="category"
              onChange={formik.handleChange("category")}
              onBlur={formik.handleBlur("category")}
              value={formik.values.category}
            >
              <option value="">Select a Category</option>
              {categories.map((cat) => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
            <div className="error">{formik.touched.category && formik.errors.category}</div>
          </div>

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Interview
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddInterview;
